export default "__VITE_ASSET__CRhgxMh0__"